module.exports = __webpack_public_path__ + "static/media/canada3.1089ddd2.jpg";